import React, { forwardRef } from 'react'
import { MenuItem } from 'components/Zui'
import { icons } from 'app/constants'
import './index.css'

const ContextMenu = ({ options, className, ...props }, ref) => {
    const classes = ['context-menu', className]

    return (
        <div {...props} className={classes.join(' ')} ref={ref}>
            <div>
                {options.map((op, index) => {
                    const ICON = icons[op.icon]
                    return (
                        <MenuItem onClick={op.onClick} key={index} size="s">
                            {op.title}
                            {ICON && <ICON slot="icon" theme="zbds-light" />}
                        </MenuItem>
                    )
                })}
            </div>
        </div>
    )
}

export default forwardRef(ContextMenu)
